import type { CompetenceScorecard, QuestionScorecard } from "@repo/ent-struct";
import { Badge } from "@repo/ui";

function Questions({ questions }: { questions: QuestionScorecard[] }) {
  return (
    <ol className="space-y-2">
      {questions.map((q) => (
        <li key={q.questionId} className="rounded-surface border border-border p-2">
          <div className="text-sm">
            <Badge variant="outline" className="mr-2 font-mono">
              {q.questionId}
            </Badge>
            {q.type && <span className="mr-1 text-muted-foreground">{q.type}</span>}
            {q.texte}
          </div>
          <ul className="mt-1 space-y-0.5 pl-4 text-xs text-muted-foreground">
            {q.criteres.map((c) => (
              <li key={c.criteriaId}>
                <span className="font-mono">{c.criteriaId}</span> · {c.description}{" "}
                <span className="tabular-nums">({c.points > 0 ? "+" : ""}{c.points})</span>
              </li>
            ))}
          </ul>
        </li>
      ))}
    </ol>
  );
}

/** Contenu d'une version en lecture seule (aperçu de l'historique). */
export function ApercuScorecard({
  competences,
}: {
  competences: CompetenceScorecard[];
}) {
  return (
    <ol className="space-y-4">
      {competences.map((competence, i) => (
        <li key={i}>
          <p className="mb-2 font-medium">
            {competence.nom}{" "}
            <span className="text-sm font-normal text-muted-foreground tabular-nums">
              — poids {competence.poids}
            </span>
          </p>
          {competence.sousCompetences?.length ? (
            <ol className="space-y-3 pl-3">
              {competence.sousCompetences.map((sous, j) => (
                <li key={j}>
                  <p className="mb-1 text-sm font-medium">{sous.nom || "Sans nom"}</p>
                  <Questions questions={sous.questions} />
                </li>
              ))}
            </ol>
          ) : (
            <Questions questions={competence.questions ?? []} />
          )}
        </li>
      ))}
    </ol>
  );
}
